import React from "react";

import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";

import CreateProjectBlank from "Components/illustrations/CreateProjectBlank";
import CreateProjectTemplate from "Components/illustrations/CreateProjectTemplate";
import PageMeta from "Components/PageMeta";
import { APP_NAME } from "Constants/documentationUrls";
import { meSelector } from "Reducers/app/selectors";
import { useOrganizationProfile } from "Reducers/organization/hooks/useOrganizationProfile";
import { useResetSetupOptionsConfig } from "Reducers/setupOptions/hooks/useResetSetupOptionsConfig";

import Card from "./Card";
import * as S from "./Type.styles";

const TypeStep = ({ goToStep, organizationId }) => {
  const intl = useIntl();

  const user = useSelector(meSelector);

  useResetSetupOptionsConfig();

  const handleClick = (e, step) => {
    e.preventDefault();
    goToStep(step);
  };

  const { organizationProfile } = useOrganizationProfile(organizationId);

  const title = (() => {
    if (
      organizationProfile?.current_trial?.active &&
      user.projects?.length === 0
    ) {
      return intl.formatMessage({ id: `setup.type.trial.title` });
    }
    return intl.formatMessage({ id: `setup.type.title` });
  })();

  return (
    <S.Wrapper>
      <PageMeta title={title} />

      <S.Header>
        <S.Title tag="h2">{title}</S.Title>
        <p>{intl.formatMessage({ id: `setup.type.description` })}</p>
      </S.Header>

      <S.Cards>
        <Card
          image={<CreateProjectTemplate aria-hidden="true" />}
          title={intl.formatMessage({ id: "setup.type.template.title" })}
          description={intl.formatMessage({
            id: "setup.type.template.description"
          })}
          onClick={e => handleClick(e, "template")}
          data-analytics-project-button="with_template"
        />

        <Card
          image={<CreateProjectBlank aria-hidden="true" />}
          title={intl.formatMessage({ id: "setup.type.empty.title" })}
          description={intl.formatMessage(
            {
              id: "setup.type.empty.description"
            },
            { appName: APP_NAME }
          )}
          onClick={e => handleClick(e, "info")}
          data-analytics-project-button="without_template"
        />
      </S.Cards>
    </S.Wrapper>
  );
};

TypeStep.propTypes = {
  goToStep: PropTypes.func,
  organizationId: PropTypes.string
};

export default TypeStep;
